// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__3q0Rt","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__19pnA"};